var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 284,
    viewBox: "0 0 221 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5798 46.5119V283.762H184.33H188.17H220.88V251.042V46.5119H51.5798Z",
    fill: "#080E04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0199 38.952V276.202H176.77H180.61H213.32V243.482V38.952H44.0199Z",
    fill: "#6CCA36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4598 31.392V268.642H169.21H173.05H205.76V235.922V31.392H36.4598Z",
    fill: "#E8FFDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.909 128.357C163.909 134.23 161.249 142.584 157.2 151.87C153.16 161.136 147.769 171.259 142.373 180.645C136.978 190.028 131.582 198.666 127.534 204.958C125.511 208.104 123.825 210.663 122.645 212.435C122.054 213.321 121.591 214.01 121.275 214.478C121.251 214.514 121.227 214.549 121.204 214.583C121.182 214.549 121.158 214.514 121.133 214.478C120.818 214.01 120.354 213.321 119.764 212.435C118.584 210.662 116.898 208.103 114.874 204.957C110.827 198.665 105.431 190.027 100.036 180.643C94.6395 171.258 89.249 161.134 85.209 151.869C81.1601 142.583 78.5 134.229 78.5 128.357C78.5 104.693 97.6198 85.5 121.204 85.5C144.789 85.5 163.909 104.685 163.909 128.357Z",
    stroke: "#080E04",
    strokeWidth: 1.0001
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.206 112.387C142.941 120.149 142.941 132.735 135.206 140.497C127.471 148.26 114.93 148.26 107.195 140.497C99.4596 132.735 99.4596 120.149 107.195 112.387C114.93 104.624 127.471 104.624 135.206 112.387Z",
    stroke: "#080E04",
    strokeWidth: 1.0001
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6029 131.373C85.6029 110.564 102.405 93.7027 123.135 93.7027C128.885 93.6982 134.559 95.0221 139.717 97.5718C144.876 100.122 149.38 103.829 152.882 108.406C149.593 102.663 144.853 97.8915 139.139 94.5746C133.426 91.2578 126.941 89.5127 120.34 89.5155C99.6143 89.5155 82.8126 106.377 82.8126 127.176C82.8032 135.483 85.5435 143.559 90.6034 150.133C87.3233 144.43 85.5985 137.959 85.6029 131.373Z",
    fill: "#6CCA36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4852 36.192C70.4852 55.2675 55.0765 70.7283 36.0725 70.7283C17.0686 70.7283 1.65982 55.2675 1.65982 36.192C1.65982 17.1164 17.0686 1.65564 36.0725 1.65564C55.0765 1.65564 70.4852 17.1164 70.4852 36.192Z",
    fill: "#6CCA36",
    stroke: "black",
    strokeWidth: 0.98322
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6188 35.6177C63.6188 50.5609 51.2939 62.6891 36.0726 62.6891C20.8512 62.6891 8.52628 50.5609 8.52628 35.6177C8.52628 20.6745 20.8512 8.54639 36.0726 8.54639C51.2939 8.54639 63.6188 20.6745 63.6188 35.6177Z",
    stroke: "black",
    strokeWidth: 0.98322
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4636 35.8052C54.4636 45.7778 46.2376 53.8764 36.0726 53.8764C25.9076 53.8764 17.6816 45.7778 17.6816 35.8052C17.6816 25.8327 25.9076 17.734 36.0726 17.734C46.2376 17.734 54.4636 25.8327 54.4636 35.8052Z",
    stroke: "black",
    strokeWidth: 0.98322
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.5002,
    y: 28.727,
    width: 1.1444,
    height: 4.59383,
    fill: "#080E04"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5002,
    y: 39.0631,
    width: 1.1444,
    height: 4.59383,
    fill: "#080E04"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.14846,
    height: 4.57762,
    transform: "matrix(0.0135238 0.999909 -0.999907 0.0136197 43.5105 35.6177)",
    fill: "#080E04"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.14846,
    height: 4.57762,
    transform: "matrix(0.0135238 0.999909 -0.999907 0.0136197 33.2111 35.6177)",
    fill: "#080E04"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.0726,
    cy: 36.192,
    rx: 4.00541,
    ry: 4.0196,
    fill: "#080E04"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a035f006a13cbbcc3dcf7fa2a15b5cf9.svg";
export { ForwardRef as ReactComponent };